module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "pagev",
      "title": "v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/List_of_Plates"
    }
  }, [_vm._v("List of Plates")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/List_of_Figures"
    }
  }, [_vm._v("List of Figures")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Abbreviations"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("1.")]), _vm._v(" The Formation of MI(R)")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("2.")]), _vm._v(" The Outbreak of War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("3.")]), _vm._v(" The Technical Section")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("4.")]), _vm._v(" Recruitment and Training")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("5.")]), _vm._v(" Escape, Evasion and Deception")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("6.")]), _vm._v(" Central and Eastern Europe")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("7.")]), _vm._v(" Romania and the Balkans")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("8.")]), _vm._v(" Scandinavia")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacet"
  }, [_vm._v("9.")]), _vm._v(" Western Europe, Britain and the Americas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacett"
  }, [_vm._v("10.")]), _vm._v(" The Caucasus, Middle East and Africa")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacett"
  }, [_vm._v("11.")]), _vm._v(" Asia, the Far East and Australia")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacett"
  }, [_vm._v("12.")]), _vm._v(" MI(R) and SOE")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On-line Appendices")]), _vm._v(" ("), _c('span', {
    staticClass: "weblink"
  }, [_c('span', {
    staticClass: "underline"
  }, [_c('a', {
    attrs: {
      "href": "https://independent.academia.edu/MalcolmAtkin",
      "target": "_blank"
    }
  }, [_vm._v("https://independent.academia.edu/MalcolmAtkin)")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Officers of MI(R), 1938–1940")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Selected source documents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0